import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const getClientCode = () => {
  try {
    const storedData = localStorage.getItem("userData");
    return JSON.parse(storedData)?.client?.code;
  } catch {
    return "";
  }
};

export const getCodeFromJWT = () => {
  try {
    // const clientCode = getClientCode(storedData);
    const token = Cookies.get("_auth");
    const decoded = jwtDecode(token);
    return decoded ? decoded?.code : getClientCode();
  } catch {
    return "";
  }
};
